const widgetDuplicate = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M2 4h1.5v8H12v1.5H2zm12-2v9H5V2zm-1.4 1.4H6.4v6.2h6.2zm-2.55 1.1v1.45h1.45v1.1h-1.45V8.5h-1.1V7.05H7.5v-1.1h1.45V4.5z"/></svg>',
};

export { widgetDuplicate as default };
